import { fromJS } from 'immutable';
import { AnyAction, Reducer } from 'redux';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SET_FETCH_PARAMS,
  FETCH_SUCCESS,
  FETCH_FAILED,
  FETCH_DONATIONS_TOTAL,
  FETCH_DONATIONS_TOTAL_SUCCESS,
  FETCH_DONATIONS_TOTAL_FAILED,
  FETCH_DEEDS_TOTAL,
  FETCH_DEEDS_TOTAL_SUCCESS,
  FETCH_DEEDS_TOTAL_FAILED,
  FETCH_VOLUNTEERHOURS_TOTAL,
  FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS,
  FETCH_VOLUNTEERHOURS_TOTAL_FAILED,
  UNBLOCK_NONPROFIT,
  UNBLOCK_NONPROFIT_SUCCESS,
  UNBLOCK_NONPROFIT_FAILED,
} from './types';

export const initialState = fromJS({
  loading: false,
  error: false,
  fetchParams: {
    search: '',
    pageNum: 0,
    limit: 10,
  },
  initialized: false,
  totals: {
    donationsTotal: { total: null, loading: false },
    deedsTotal: { total: null, loading: false },
    volunteerHoursTotal: { total: null, loading: false },
  },
});

export default (state = initialState, action: AnyAction): Reducer => {
  switch (action.type) {
    case INIT:
      return state.merge({
        fetchParams: initialState.get('fetchParams'),
        loading: true,
        initialized: false,
      });

    case SET_FETCH_PARAMS:
      return state.merge({
        loading: true,
        fetchParams: state.get('fetchParams').merge({ pageNum: 0, ...action.params }),
      });

    case FETCH_DONATIONS_TOTAL:
      return state.setIn(['totals', 'donationsTotal', 'loading'], true);

    case FETCH_DONATIONS_TOTAL_SUCCESS:
      return state
        .setIn(['totals', 'donationsTotal', 'loading'], false)
        .setIn(['totals', 'donationsTotal', 'total'], action.donationsTotal);

    case FETCH_DONATIONS_TOTAL_FAILED:
      return state
        .setIn(['totals', 'donationsTotal', 'loading'], false)
        .setIn(['totals', 'error'], action.error);

    case FETCH_DEEDS_TOTAL:
      return state.setIn(['totals', 'deedsTotal', 'loading'], true);

    case FETCH_DEEDS_TOTAL_SUCCESS:
      return state
        .setIn(['totals', 'deedsTotal', 'loading'], false)
        .setIn(['totals', 'deedsTotal', 'total'], action.deedsTotal);

    case FETCH_DEEDS_TOTAL_FAILED:
      return state
        .setIn(['totals', 'deedsTotal', 'loading'], false)
        .setIn(['totals', 'error'], action.error);

    case FETCH_VOLUNTEERHOURS_TOTAL:
      return state.setIn(['totals', 'volunteerHoursTotal', 'loading'], true);

    case FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS:
      return state
        .setIn(['totals', 'volunteerHoursTotal', 'loading'], false)
        .setIn(['totals', 'volunteerHoursTotal', 'total'], action.volunteerHoursTotal);

    case FETCH_VOLUNTEERHOURS_TOTAL_FAILED:
      return state
        .setIn(['totals', 'volunteerHoursTotal', 'loading'], false)
        .setIn(['totals', 'error'], action.error);

    case INIT_SUCCESS:
    case FETCH_SUCCESS:
      return state.merge({
        loading: false,
        total: action.total,
        initialized: true,
      });

    case INIT_FAILED:
    case FETCH_FAILED:
      return state.merge({
        loading: false,
        error: action.error,
        initialized: true,
      });

    case UNBLOCK_NONPROFIT:
      return state.set('unblockNonprofitSubmitting', true);

    case UNBLOCK_NONPROFIT_SUCCESS:
    case UNBLOCK_NONPROFIT_FAILED:
      return state.set('unblockNonprofitSubmitting', false);

    default:
      return state;
  }
};
